export { Tabs } from "./Tabs";
export type { Tab, TabAction } from "./Tabs";
